<script>
	import { TwitchIcon, VideoIcon } from 'svelte-feather-icons'
	import { createEventDispatcher } from 'svelte';
	var dispatch = createEventDispatcher();
	import { onMount } from 'svelte';
	import { io } from './store.js';
	
	onMount(() => {

	});
	
</script>

<div class='con-header'>
	<img class='img-header' src='fgcards_logo.png'/>
	<a href='/' class='div-page {$io.activePage == 'Landing' ? 'selected': ''}'>Home</a>
	<a href='/howtoplay'  class='div-page {$io.activePage == 'HowToPlay' ? 'selected': ''}'>How To Play</a>
	<a href='/contact' class='div-page {$io.activePage == 'Contact' ? 'selected': ''}'>Contact</a>
	<a href = '/setup' class='div-page rewards {$io.activePage == 'Setup' ? 'selected': ''}'>Setup Guide</a>
</div>

<style type="text/less">
	.con-header{
		display:grid;
		grid-template-columns: auto min-content min-content min-content min-content;
		column-gap:21px;
		align-items: center;;

		.div-page{
			white-space: nowrap;
			font-size:1.15em;
			color:white !important;

			&:hover{
				cursor:pointer;
				text-decoration: underline;;
			}

			&.selected{
				color:#f6ff00c9 !important;;
			}

			&.rewards{
				background-color:#f6ff00;
				padding:6px 12px;
				color:black !important;
				border-radius:10px;
			}
		}

		img{
			width:130px;
		}
	}
</style>

